import http from '@/http-common.js'

class OwnersService {
  basePathApiService = '/owners'
  getAll(params) {
    return http.get(this.basePathApiService, params)
  }
  create(createData) {
    return http.post(this.basePathApiService, createData)
  }
  editOne(id, editData) {
    return http.patch(this.basePathApiService + `/${id}`, editData)
  }
  editMultiple(id, editData) {
    return http.put(this.basePathApiService + `/${id}`, editData)
  }
  delete(id) {
    return http.delete(this.basePathApiService + `/${id}`)
  }
}
export default new OwnersService()
